export default "__VITE_ASSET__07d22c6a__"